import { differenceInDays, parseISO, format } from "date-fns";
import { it } from "date-fns/locale";

/**
 * Returns { level, days, label, className, bar }
 * level: 'green' | 'yellow' | 'orange' | 'red' | 'none'
 */
export function trafficLight(deadlineIso, delivered) {
  if (delivered) return { level: "green", days: null, label: "Consegnata", className: "tl-green", bar: "tl-bar-green" };
  if (!deadlineIso) return { level: "none", days: null, label: "Nessuna scadenza", className: "bg-neutral-100 text-neutral-600 border-neutral-200", bar: "bg-neutral-300" };
  try {
    const d = typeof deadlineIso === "string" ? parseISO(deadlineIso) : deadlineIso;
    const days = differenceInDays(d, new Date());
    if (days < 5) return { level: "red", days, label: `${days < 0 ? "Scaduta" : days + "g"}`, className: "tl-red", bar: "tl-bar-red" };
    if (days <= 10) return { level: "orange", days, label: `${days}g`, className: "tl-orange", bar: "tl-bar-orange" };
    return { level: "yellow", days, label: `${days}g`, className: "tl-yellow", bar: "tl-bar-yellow" };
  } catch {
    return { level: "none", days: null, label: "-", className: "bg-neutral-100 text-neutral-600 border-neutral-200", bar: "bg-neutral-300" };
  }
}

export const fmtEUR = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try { return format(parseISO(iso), "dd MMM yyyy", { locale: it }); } catch { return iso; }
};

export const fmtDateShort = (iso) => {
  if (!iso) return "-";
  try { return format(parseISO(iso), "dd/MM/yy", { locale: it }); } catch { return iso; }
};
